import { z } from 'zod';

export const CampaignAdvertiser = z.string().min(1, {
  message:
    'This field is required. The advertiser name should have at least 1 character',
});

export type CampaignAdvertiser = z.infer<typeof CampaignAdvertiser>;
